import { firebaseApp } from "../firebase";
import {
  getAuth,
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { getDatabase, ref, child, get, push, update } from "firebase/database";

const db = getDatabase(firebaseApp);
const dbRef = ref(db);

const state = {
  user: undefined,
  nusers: 0,
  users: [],
  autorizados: [],
  verificaAdmin: false,
  logado: {},
  error: "",
};

const getters = {
  user(state) {
    return state.user;
  },
  users(state) {
    return state.users;
  },
  nusers(state) {
    return state.nusers;
  },
  autorizados(state) {
    return state.autorizados;
  },
  verificaAdmin(state) {
    return state.verificaAdmin;
  },
  logado(state) {
    return state.logado;
  },
  error(state) {
    return state.error;
  },
};

const actions = {
  setError({ commit }, txt) {
    commit("setError", txt);
  },
  createUser({ commit }, obj) {
    try {
      const email = obj.email;
      const password = obj.pass;
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed up
          const user = userCredential.user;
          console.log(user.email);
          // dispatch("onChanged");
        })
        .catch((error) => {
          console.log(error.code);
          const errorCode = error.code;
          // const errorMessage = error.message;
          commit("setError", errorCode);
        });
    } catch (error) {
      console.log(error);
    }
  },
  loginEmailPass({ commit, dispatch }, obj) {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, obj.email, obj.pass)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        console.log(user.email);
        dispatch("onChanged");
      })
      .catch((error) => {
        const errorCode = error.code;
        // const errorMessage = error.message;
        console.log(errorCode);
        commit("setError", errorCode);
      });
  },
  login({ dispatch, commit }) {
    return new Promise((resolve) => {
      const auth = getAuth(firebaseApp);
      const provider = new GoogleAuthProvider();

      signInWithPopup(auth, provider)
        .then((result) => {
          const credential = GoogleAuthProvider.credentialFromResult(result);
          // const token = credential.accessToken;
          console.log(credential.providerId);
          // dispatch("checkAndCreateUser", result.user);
          dispatch("onChanged");
          resolve(result.user);
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          // The email of the user's account used.
          // const email = error.customData.email;
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);
          const msg = { errorCode, errorMessage, credential };
          commit("setError", msg);
          resolve(null);
        });
    });
  },
  loadUser({ commit }, uid) {
    return new Promise((resolve) => {
      get(child(dbRef, "users/" + uid))
        .then((snapshot) => {
          if (snapshot.exists()) {
            const user = {};
            const obj = snapshot.val();
            user.nome = obj.nome;
            user.email = obj.email;
            user.cel = obj.cel;
            user.foto = obj.foto;
            user.desc = obj.desc;
            user.aceite = obj.aceite;
            user.uid = uid;
            user.tabdef = obj.tabdef;
            user.cancel = obj.cancel;
            if (user.cancel) {
              resolve({cancel: true});
            } else {
              commit("setUser", obj);
              resolve(obj);
            }
          } else {
            commit("setUser", undefined);
            resolve(undefined);
          }
        })
        .catch((error) => {
          console.error(error);
          commit("setUser", undefined);
          resolve(undefined);
        });
    });
  },
  loadUsers({ commit }) {
    get(child(dbRef, "users/"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const users = [];
          const obj = snapshot.val();
          let novo = 0
          for (const key in obj) {
            users.push({
              uid: key,
              nome: obj[key].nome,
              email: obj[key].email,
              cel: obj[key].cel,
              foto: obj[key].foto,
              aceite: obj[key].aceite,
              tabdef: obj[key].tabdef,
              desc: obj[key].desc,
              cancel: obj[key].cancel,
              novo: obj[key].novo
            });
            if(obj[key].novo) {
              novo++
            }
          }
          commit("setNusers", novo)
          commit("setUsers", users);
        } else {
          commit("setUsers", []);
        }
      })
      .catch((error) => {
        console.error(error);
        commit("setUser", undefined);
      });
  },
  loadAutorizados({ commit }) {
    get(child(dbRef, "admin/autorizados"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          const aut = [];
          const obj = snapshot.val();
          for (const key in obj) {
            aut.push({
              id: key,
              uid: obj[key].uid,
            });
          }
          commit("loadAutorizados", aut);
        } else {
          console.log("No data available");
          commit("loadAutorizados", []);
        }
      })
      .catch((error) => {
        console.error(error);
        commit("loadAutorizados", []);
      });
  },
  saveAutorizado({ commit }, obj) {
    const db = getDatabase(firebaseApp);
    let key;
    push(ref(db, "admin/autorizados"), obj)
      .then((data) => {
        key = data.key;
        return key;
      })
      .then((key) => {
        commit("saveAutorizado", key);
      });
  },
  updateAutorizado({ commit }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["admin/autorizados/" + obj.id + "/uid"] = obj.uid;
    update(ref(db), updates);
    commit("updateAutorizado", true);
  },
  deleteAutorizado({ commit }, id) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["admin/autorizados/" + id] = null;
    update(ref(db), updates);
    commit("deleteAutorizado", true);
  },
  checkAndCreateUser({ commit }, user) {
    get(child(dbRef, `users/${user.uid}`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log("Usuário já existe:", snapshot.val());
        } else {
          dbRef.set({
            uid: user.uid,
            nome: user.displayName,
            email: user.email,
            foto: user.photoURL,
            cel: user.phoneNumber,
          });
          console.log("Usuário criado:");
        }
      })
      .catch((error) => {
        commit("setError", "Erro ao verificar/criar usuário:" + error);
      });
  },
  insertUser({ commit, dispatch }, obj) {
    try {
      const db = getDatabase(firebaseApp);
      const updates = {};
      updates["users/" + obj.uid] = obj;
      update(ref(db), updates).catch((error) => {
        console.log(error.key);
        commit("setError", error.key);
        commit("setUser", obj);
        dispatch("loadUser", obj.uid);
      });
      commit("setUser", obj);
      dispatch("loadUser", obj.uid);
    } catch (error) {
      console.error("Erro ao salvar os dados: ", error);
      // commit("setError", error.key);
      commit("setUser", obj);
      dispatch("loadUser", obj.uid);
    }
  },
  updateUser({ commit }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["users/" + obj.uid] = obj;
    update(ref(db), updates);
    commit("setUser", obj);
  },
  setDesc({ dispatch }, obj) {
    const db = getDatabase(firebaseApp);
    const updates = {};
    updates["users/" + obj.uid + "/desc/"] = obj.desc;
    updates["users/" + obj.uid + "/tabdef/"] = obj.tabdef;
    updates["users/" + obj.uid + "/cancel/"] = obj.cancel;
    if(obj.novo === null){
      updates["users/" + obj.uid + "/novo/"] = obj.novo;
    }
    update(ref(db), updates);
    // dispatch("loadUser", obj.uid);
    dispatch("loadUsers");
  },
  onChanged({ commit }) {
    return new Promise((resolve) => {
      const auth = getAuth(firebaseApp);
      onAuthStateChanged(auth, (userCredential) => {
        if (userCredential) {
          const obj = {
            uid: userCredential.uid,
            email: userCredential.email,
            cel: userCredential.phoneNumber,
            nome: userCredential.displayName,
            foto: userCredential.photoURL,
          };
          commit("setLogado", obj);
          console.log(userCredential.email);
          // dispatch("loadUser", obj.uid);
          // dispatch("loadAutorizados");
          resolve(obj);
        } else {
          // User is signed out
          commit("setLogado", false);
          commit("setUser", undefined);
          resolve(userCredential);
        }
      });
    });
  },
  logOut({ commit }) {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        commit("logOut");
        commit("setUser", undefined);
        commit("setLogado", undefined);
        commit("setVerificaAdmin", false);
      })
      .catch((error) => {
        // An error happened.
        console.log(error);
      });
  },
  destroyUser({ commit }, obj) {
    commit("setUser", obj);
    commit("setLogado", obj);
  },
  setVerificaAdmin({ commit }, obj) {
    // Object.keys(this.user).length > 0
    const uid = obj.uid;
    const admins = obj.admins;
    let res = false;
    for (let i = 0; i < admins.length; i++) {
      const admin = admins[i];
      if (uid === admin.uid) {
        res = true;
      }
    }
    commit("setVerificaAdmin", res);
  },
};

const mutations = {
  setVerificaAdmin(state, payload) {
    state.verificaAdmin = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setUsers(state, payload) {
    state.users = payload;
  },
  setNusers(state, payload){
    state.nusers = payload
  },
  loadAutorizados(state, payload) {
    state.autorizados = payload;
  },
  saveAutorizado(payload) {
    console.log(payload);
  },
  updateAutorizado(payload) {
    console.log(payload);
  },
  deleteAutorizado(payload) {
    console.log(payload);
  },
  destroyUser(state, payload) {
    state.user = payload;
  },
  updateUser(state, payload) {
    state.user = payload;
  },
  setError(state, obj) {
    state.error = obj;
  },
  setLogado(state, payload) {
    state.logado = payload;
  },
  logOut(state) {
    state.logado = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
